/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */

'use strict';

var DraftEditorContents = require('./DraftEditorContents-core.react');

module.exports = DraftEditorContents;


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/DraftEditorContents.react.js
 ** module id = 649
 ** module chunks = 0
 **/